import serviceBase from '../../../../Services/serviceBase'

class ResidentialPlansReportActions {
  getResidentialPlansReport = async (payload) => {
    let url = `${window._env_.COMMUNITY_API_URL || 'https://communityapi-qa.iartest.com/api/v1'
    }/residential-plan-logs/getResidentialPlanLogs`
    return serviceBase.post(url, payload).then(
      (response) => {
        return response.data
      },
      (err) => { }
    )
  }
}

export default new ResidentialPlansReportActions()
